import { render, staticRenderFns } from "./nxVideoPreview.vue?vue&type=template&id=e25d1d86&scoped=true&"
import script from "./nxVideoPreview.vue?vue&type=script&lang=js&"
export * from "./nxVideoPreview.vue?vue&type=script&lang=js&"
import style0 from "./nxVideoPreview.vue?vue&type=style&index=0&id=e25d1d86&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25d1d86",
  null
  
)

export default component.exports